module.exports = __webpack_public_path__ + "static/media/advertisement-speaker.9f8303c7.svg";